export default function particleVowels(string) {
  const vowels = ['a', 'e', 'i', 'o', 'u', 'y'];
  return vowels.includes(string.charAt(0)) ? "d'" : 'de ';
}
